import { Helmet } from 'react-helmet-async';
import React, { useState, useEffect, useLayoutEffect } from 'react';
import {
  Slide,
  IconButton,
  ClickAwayListener,
  InputBase,
  Button,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Tabs,
  Tab,
  Box,
  Modal,
  Divider,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  TextField,
  FormControlLabel,
  RadioGroup,
  Radio,
  Checkbox,
  ListItemText,
  OutlinedInput,
  CircularProgress,
  Link,
  Avatar,
  InputAdornment,
  Skeleton,
  Container,
  Card,
  CardContent,
  FormLabel,
} from '@mui/material';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { useLocation, useNavigate } from 'react-router-dom';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { styled, alpha } from '@mui/material/styles';
import MyCustomUploadAdapterPlugin from './customEditor/customEditor';
import countries from './countryJson/countryJson.json';
import Iconify from '../components/iconify';
import { Api, UploadFile } from '../webservices';

// Styled Components
const StyledCardMedia = styled('div')({
  position: 'relative',
  //   paddingTop: 'calc(100% * 3 / 4)',
});

const StyledTitle = styled(Link)({
  height: 44,
  overflow: 'hidden',
  // WebkitLineClamp: 2,
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
});

const StyledAvatar = styled(Avatar)(({ theme }) => ({
  zIndex: 9,
  width: 32,
  height: 32,
  position: 'absolute',
  left: theme.spacing(3),
  bottom: theme.spacing(-2),
}));

const StyledInfo = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'flex-end',
  marginTop: theme.spacing(3),
  color: theme.palette.text.disabled,
}));

const StyledCover = styled('img')({
  top: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute',
});

const formatNumber = (num) => (num >= 1000 ? `${(num / 1000).toFixed(1)}k` : num);

// class ClassicEditor extends ClassicEditorBase {}
// ClassicEditor.builtinPlugins = [
//     ...ClassicEditorBase.builtinPlugins,
//     Base64UploadAdapter
// ];

export default function Profile() {
  // const t = process.env.REACT_APP_TLK
  // console.log("t", t)
  const navigate = useNavigate();
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [name, setName] = useState('');
  const [signList, setSignList] = useState([]);
  const [details, setDetails] = useState([]);
  const [details1, setDetails1] = useState([]);
  const [selectedSignatureId, setSelectedSignatureId] = useState('');
  const [modalOpen1, setModalOpen1] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [updatedName, setUpdatedName] = useState('');
  const [selectedSignature, setSelectedSignature] = useState(null);
  const [profileImage, setProfileImage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState('');
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [fileInputFiles, setFileInputFiles] = useState();
  const [country, setCountry] = useState(localStorage.getItem('country'));
  const [timeZone, setTimeZone] = useState({
    shortName: '',
    fullName: '',
  });

  const timeZones = [
    { short: 'EST', full: 'America/New_York' },
    { short: 'PST', full: 'America/Los_Angeles' },
    { short: 'MST', full: 'America/Denver' },
    { short: 'CST', full: 'America/Chicago' },
    { short: 'IST', full: 'Asia/Kolkata' },
  ];

  const handleChange = (event) => {
    const selectedShort = event.target.value;
    const selectedZone = timeZones.find((tz) => tz.short.toLowerCase() === selectedShort);

    if (selectedZone) {
      setTimeZone({
        shortName: selectedZone.short,
        fullName: selectedZone.full,
      });
    }
  };

  const [contactPName, setContactPName] = useState();
  const [profileStore, setProfileStore] = useState();

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleOpenModal1 = () => {
    setModalOpen1(true);
  };

  const handleCloseModal1 = () => {
    setModalOpen1(false);
  };

  useLayoutEffect(() => {
    getDetails();
    GetSign();
  }, []);

  const getDetails = () => {
    const token = localStorage.getItem('token');
    Api('company/get_user_details', 'GET', '', token).then((response) => {
      if (response.status === 200 && response.data.data) {
        console.log('country is condition ==>>', response);
        localStorage.setItem('country', response.data?.data?.country);
        localStorage.setItem('timeZone', response.data?.data?.timeZone?.shortName);

        console.log('=====>>>', response.data.data);
        console.log('=====>>>', response.data.companyDetail);
        setDetails(response.data.data);
        setDetails1(response.data?.companyDetail);
      }
    });
  };

  const handleOpenDeleteModal = (signatureId) => {
    setSelectedSignatureId(signatureId);
    setDeleteModalOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModalOpen(false);
  };

  const AddSign = () => {
    if (!name.trim()) {
      toast.warn('Please fill input field!');
      return;
    }

    const body = {
      "name": name,
    };
    const token = localStorage.getItem('token');
    Api('email/signature/set', 'POST', body, token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          toast.success('Signature added successfully!');
          GetSign();
          setName('');
          handleCloseModal1();
        } else {
          toast.warn(`${Response.data.status}!`);
        }
      } else {
        toast.warn('Error!');
      }
    });
  };

  const GetSign = () => {
    const token = localStorage.getItem('token');
    Api('email/signature/getAll', 'GET', '', token).then((response) => {
      if (response.status === 200) {
        if (response.data.code === 200) {
          setSignList(response.data.result);
          localStorage.setItem('sign', response.data?.result?.[0]?.signature?.name ?? '');
        } else {
          // console.log('data:', response.data.message);
        }
      }
    });
  };

  const DeleteSign = () => {
    const body = {
      signatureId: selectedSignatureId,
    };
    const token = localStorage.getItem('token');
    Api('email/signature/delete', 'POST', body, token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          toast.success('Signature deleted successfully!');
          GetSign();
          handleCloseDeleteModal();
        } else {
          toast.warn(`${Response.data.status}!`);
        }
      } else {
        toast.warn('Error!');
      }
    });
  };

  const handleUpdateNameChange = (event, editor) => {
    const data = editor.getData();
    setUpdatedName(data);
  };

  const handleOpenUpdateModal = (signature) => {
    setSelectedSignature(signature);
    setUpdatedName(signature.signature.name);
    setModalOpen(true);
  };

  const UpdateSign = () => {
    if (!updatedName.trim()) {
      toast.warn('Please fill input field!');
      return;
    }

    const body = {
      signatureId: selectedSignature._id,
      name: updatedName,
    };

    const token = localStorage.getItem('token');
    Api('email/signature/update', 'POST', body, token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          toast.success('Signature updated successfully!');
          GetSign();
          handleCloseModal();
        } else {
          toast.warn(`${Response.data.status}!`);
        }
      } else {
        toast.warn('Error!');
      }
    });
  };

  // const [imagePreview, setImagePreview] = useState(null);

  const modalOpene = () => {
    setShowModal(true);
  };
  const modalClosee = () => {
    setShowModal(false);
  };

  const handleFileSelect = (e) => {
    // setLoading("Please wait...")
    const file = e.target.files[0];
    setFileInputFiles(file);
    if (file) {
      uploadMulti(file);
    }
  };

  const uploadMulti = async (file) => {
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('document', file);
    formData.append('directoryName', 'profile');
    try {
      const response = await UploadFile('resume/upload_resume', formData, token);
      if (response.status === 200 && response.data.code === 200) {
        setProfileStore(response.data.filePath);
        const uploadedImageUrl = response.data.filePath;
        //   setProfileImage(uploadedImageUrl);
        // UploadImage(uploadedImageUrl)
        //   setImagePreview(URL.createObjectURL(file));
      } else {
        //   toast.warn(response.data.status + '!');
      }
    } catch (error) {
      // toast.warn('Error uploading the image!');
    }
  };

  const UploadImage = () => {
    // if (!profileStore && !localStorage.getItem("image")) {
    //   toast.warn("Profile is required")
    //   return;
    // }
    setLoadingBtn(true);
    const body = {
      profileUrl: profileStore || localStorage.getItem('image'),
      // "profileUrl": parseres,
      country: country || details?.country,
      contactPersonName: contactPName || details?.contactPersonName,
      // "timeZone":timez || details?.timeZone
      timeZone: {
        shortName: timeZone.shortName,
        fullName: timeZone.fullName,
      },
    };
    const token = localStorage.getItem('token');
    Api('company/uploadProfileImage', 'POST', body, token)
      .then((Response) => {
        if (Response.status === 200) {
          setLoadingBtn(false);
          getDetails();
          toast.success(Response.data.resmessage);
          // setFileInputFiles('')
          // setLoading('')
          localStorage.setItem('image', Response.data.profileUrl);
          modalClosee();
          // setProfileStore('')
          // setCountry('')
          // setContactPName('')
          // console.log("Profile image uploaded successfully!");
        } else {
          console.log('hello shyamlal sharma ');
          toast.success('something went wrong ');
          setLoadingBtn(false);
          // console.error(`Error uploading profile image: ${Response.statusText}`);
        }
      })
      .catch((error) => {
        // console.error("Error during upload: ", error);
      });
  };

  useEffect(() => {
    if (showModal) {
      setContactPName(details?.contactPersonName || '');
      setCountry(details?.country || '');
      setFileInputFiles(localStorage.getItem('image') || '');
      // setTimeZone(details?.timeZone || '')
      setTimeZone({
        shortName: details?.timeZone?.shortName || '',
        fullName: details?.timeZone?.fullName || '',
      });
    }
  }, [showModal]);

  const [valuee, setValuee] = React.useState('profile');

  const [files, setFiles] = useState([]);
  const [message, setMessage] = useState('');
  const [loadingFile, setLoadingFile] = useState(false);

  const selectMultiFile = (e) => {
    const selectedFiles = Array.from(e.target.files);

    const invalidFiles = selectedFiles.filter((file) => {
      const ext = file?.name?.split('.')?.pop()?.toLowerCase();
      return !['csv', 'xlsx'].includes(ext);
    });

    if (invalidFiles.length > 0) {
      setMessage('Only CSV or XLSX files are allowed.');
      setFiles([]);
      e.target.value = '';
      return;
    }

    if (selectedFiles.length !== 2) {
      setMessage('Please select exactly 2 files (one Candidate + one Notes).');
      setFiles([]);
      e.target.value = '';
      return;
    }

    setFiles(selectedFiles);
    setMessage('');
  };
  console.log('[]=>', country);
  const handleUpload = async () => {
    if (files.length !== 2) {
      setMessage('You must select exactly 2 files before uploading.');
      return;
    }

    setLoadingFile(true);
    setMessage('');

    const formData = new FormData();
    const token = localStorage.getItem('token');

    formData.append('file1', files[0]);
    formData.append('file2', files[1]);

    try {
      const res = await UploadFile('company/add_candidate/byfiles', formData, token);

      if (res.status === 200) {
        // console.log("res---", res)
        toast.success(res.data?.message);
        setMessage(`${res.data?.message} (${res.data?.totalMatched} matched)`);
        setFiles([]);
        document.getElementById('fileInput').value = '';
      } else if (res.status === 400) {
        // console.log("res1", res)
        setMessage(res.data?.error);
        document.getElementById('fileInput').value = '';
        setFiles([]);
        // toast.warn(res.data?.error);
      } else if (res.status === 404) {
        //  console.log("res2", res)
        setMessage(res.data?.message);
        document.getElementById('fileInput').value = '';
        setFiles([]);
        // toast.warn(res.data?.message);
      }
    } catch (err) {
      // console.log(err);
    } finally {
      setLoadingFile(false);
    }
  };

  const isEditable = country === 'USA' || country === 'CANADA';

const filteredCountries = isEditable
  ? countries.filter((item) =>
      ['USA', 'CANADA'].includes(item.country)
    )
  : countries;
 console.log("[]{}=>>",country )
console.log("hellocountyr ====>>", filteredCountries)

const [openQuestionModal, setOpenQuestionModal] = useState(false);
const [fixedQuestion, setFixedQuestion] = useState("");
const [questionList, setQuestionList] = useState([]);
const [orders, setOrders] = useState("");
const [openEditQuestionModal, setOpenEditQuestionModal] = useState(false);
const [editQuestion, setEditQuestion] = useState({});




const listFixedQuestions = () => {
     
    
    const token = localStorage.getItem("token")
     Api('bot/list_hr_questions', 'GET', '', token)
       .then((res) => {
         console.log(res);
         if (res.status === 200) {
           if (res.data.success) {
            //  toast.success(res.data.message)
             setQuestionList(res.data.data);
           } else {
             toast.success(res.data.message);
           }
         }
       })
       .catch((err) => {
         console.log(err);
       });
   };


const addTechQuestions = () => {
    
     const body = {
    question: fixedQuestion,
    order: Number(orders)
     }
     console.log("body++==>>",body)
    const token = localStorage.getItem("token")
     Api('bot/create_hr_question', 'POST', body, token)
       .then((res) => {
         console.log(res);
         if (res.status === 200) {
           if (res.data.success) {
             toast.success(res.data.message)
             setFixedQuestion("");
             setOrders("");
             setOpenQuestionModal(false);
             listFixedQuestions();
           } else {
             toast.success(res.data.message);
           }
         }
       })
       .catch((err) => {
         console.log(err);
       });
   };

   const updateQuestion = async () => {
  const token = localStorage.getItem("token");

  const payload = {
    id: editQuestion._id, // ya editQuestion.id
    question: fixedQuestion,
    order: Number(orders),
    isActive: editQuestion.isActive,
  };

  const res = await Api(
    "bot/update_hr_question",
    "POST",
    payload,
    token
  );

  if (res.data.success) {
    toast.success("Question Updated Successfully");
    setOpenEditQuestionModal(false);
    setFixedQuestion("");
    setOrders("");
    listFixedQuestions(); // Refresh list
  }
};

const handleDeleteQuestion = async (item) => {
  const token = localStorage.getItem('token');

  const payload = {
    ids: [
        item._id
    ]
  }

  const res = await Api('bot/delete_hr_question','POST', payload, token);
  if(res.data.success){
    toast.success(res.data.message);
    listFixedQuestions();

  }
};

  return (
    <>
      <Helmet>
        <title> Dashboard: Profile | Foxearch </title>
      </Helmet>

      <Stack>
        <Iconify
          icon="ion:arrow-back"
          fontSize={30}
          sx={{
            cursor: 'pointer',
            color: 'text.secondary',
            fontSize: '0.9rem',
            fontWeight: '600',
            mb: 0.4,
          }}
          onClick={() => navigate(-1)}
        />
      </Stack>

      <Stack sx={{ p: 0.5 }}>
        {/* <Stack direction="row" alignItems="center" justifyContent="space-between" mb={0.1}> */}
        <Typography variant="h5" color={'text.secondary'} sx={{}}>
          Setting
        </Typography>

        <Stack
          sx={{
            flexDirection: 'row',
            gap: 2,
            cursor: 'pointer',
            alignItems: 'center',
            width: '100%',
            justifyContent: 'flex-start',
            mb: 1.2,
            mt: 0.5,
          }}
        >
          <Stack
            sx={[
              { flexDirection: 'row', alignItems: 'center' },
              valuee === 'profile' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
            ]}
            onClick={() => {
              setValuee('profile');
              setMessage('');
              document.getElementById('fileInput').value = '';
              setLoadingFile(false);
              setFiles([]);
            }}
          >
            <Iconify icon="gridicons:multiple-users" fontSize={17} />
            <Typography variant="tabs" sx={{ ml: 1 }}>
              Profile
            </Typography>
          </Stack>

          <Stack
            sx={[
              { flexDirection: 'row', ml: 1, alignItems: 'center' },
              valuee === 'parse' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
            ]}
            onClick={() => {
              setValuee('parse');
            }}
          >
            <Iconify icon="mdi:sign-real-estate" fontSize={17} color={valuee === 'parse' ? '#F4D03F' : 'text.textG'} />
            <Typography variant="tabs" sx={{ ml: 1 }}>
              Parse Candidate
            </Typography>
          </Stack>

          {(localStorage.getItem('role') === 'superadmin') && (
           <Stack
            sx={[
              { flexDirection: 'row', ml: 1, alignItems: 'center' },
              valuee === 'question' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
            ]}
            onClick={() => {
              setValuee('question');
              listFixedQuestions();
            }}
          >
            <Iconify icon="mdi:sign-real-estate" fontSize={17} color={valuee === 'parse' ? '#F4D03F' : 'text.textG'} />
            <Typography variant="tabs" sx={{ ml: 1 }}>
              HR Questions
            </Typography>
          </Stack>
           )}
        </Stack>
        {/* </Stack> */}
        {/* <Stack>
                    <Iconify icon="ion:arrow-back" fontSize={30}
                        sx={{
                            cursor: 'pointer', color: 'text.secondary', fontSize: '0.9rem',
                            fontWeight: '600', mb: 1
                        }} onClick={() => navigate(-1)} />
                </Stack> */}

{valuee === "question" ? (
  <Card
    sx={{
      p: 2,
      border: "2px solid #1E74B3",
      borderRadius: 2,
    }}
  >
    {/* Header */}
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        mb: 2,
      }}
    >
      <Button
        variant="contained"
        color="custom"
        onClick={() =>  setOpenQuestionModal(true)
          // handleOpenQuestionModal
        } // Modal Open
      >
        Add Question
      </Button>
    </Box>

    {/* Table */}
    <TableContainer component={Paper} elevation={0}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow sx={{ justifyContent: 'flex-start', backgroundColor: 'text.secondary' }}>
            <TableCell sx={{ p: 1, py: 0.5, fontWeight: 600, color: 'white' }}>Q No.</TableCell>
            <TableCell sx={{ p: 1, py: 0.5, fontWeight: 600, color: 'white' }}>Question</TableCell>
            <TableCell align="center" sx={{ p: 1, py: 0.5, fontWeight: 600, color: 'white' }}>
              Action
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {questionList?.length > 0 ? (
            questionList.map((item, index) => (
              <TableRow key={item._id || index}>
                <TableCell>{index + 1}</TableCell>

                <TableCell>{item.question}</TableCell>

                <TableCell align="center">
                  <Box sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
                  <Button
                    variant="contained"
                    size="small"
                    color="custom"
                     onClick={() => {
                      setEditQuestion(item);
                      setOrders(item.order);
                      setFixedQuestion(item.question);
                      setOpenEditQuestionModal(true);
                    }}
                  >
                    Edit
                  </Button>

                  <Button
                   variant="contained"
                   size="small"
                   color="custom"
                   onClick={() =>
                    // alert('delete hr question')
                     handleDeleteQuestion(item)
                    }
                   >
                   Delete
               </Button>
               </Box>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={3} align="center">
                No Questions Found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  </Card>
) : 

        valuee === 'profile' ? (
          <Grid container spacing={2}>
            {/* <Grid item xs={12} sm={6}> */}
            {/* <Card sx={{ position: 'relative' }}>
  <StyledCardMedia
    sx={{
      pt: 'calc(65%)',
      position: 'relative',
      '&:after': {
        top: 0,
        content: "''",
        width: '100%',
        height: '100%',
        position: 'absolute',
        backgroundColor: 'rgba(35, 5, 5, 0.72)',
      },
    }}
  >

    <Box
      sx={{
        position: 'absolute',
        top: 16,
        right: 16,
        zIndex: 9,
      }}
    >
      <Button
        size="small"
        variant="contained"
        color="primary"
        onClick={handleOpenModal1}
        disabled={signList?.length === 1}
      >
        Add Signature
      </Button>
    </Box>
  </StyledCardMedia>

  {signList.length > 0 &&
    signList.map((item, index) => (
      <CardContent
        key={item._id || index}
        sx={{
          position: 'absolute',
          top: 15,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 8,
          padding: 4,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          overflow: 'hidden', 
        }}
      >
    
        <Typography
          variant="h5"
          sx={{
            color: 'common.white',
            whiteSpace: 'pre-wrap',
            overflowY: 'auto', 
            flex: 1,
          }}
        >
          <Typography sx={{ fontWeight: 'bold' }} dangerouslySetInnerHTML={{ __html: item.signature.name }} />
        </Typography>

        <Box
          sx={{
            mt: 1,
            display: 'flex',
            justifyContent: 'center',
            position: 'absolute',
            bottom: 10,
            left: 0,
            right: 0,
            
          }}
        >
          <Stack direction="row" spacing={2} justifyContent="center">
            <Button
              size="small"
              variant="contained"
              color="primary"
              onClick={() => handleOpenUpdateModal(item)}
            >
              Update
            </Button> 
            <Button
              size="small"
              variant="contained"
              color="error"
              onClick={() => handleOpenDeleteModal(item._id)}
            >
              Delete
            </Button>
          </Stack>
        </Box>
      </CardContent>
    ))}
</Card> */}

            {/* <Button
        size="small" 
        variant="contained"
        color="primary"
        onClick={handleOpenModal1}
        disabled={signList?.length === 1}
      >
        Add Signature
      </Button>  */}
            <Grid item xs={12} sm={6}>
              <Card
                sx={{
                  border: '2px solid #1E74B3',
                  transition: 'transform 0.1s, box-shadow 0.1s',
                  width: '100%',
                  // height: '100%',
                  height: 360,
                  display: 'flex',
                  flexDirection: 'column',
                  // border: '2px solid #1E74B3',
                  // '&:hover': {
                  //     transform: 'scale(1.01)',
                  //     boxShadow: '0 5px 10px rgba(0,0,0,0.2)',
                  // },
                }}
              >
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
                  <Button
                    size="small"
                    variant="contained"
                    color="custom"
                    onClick={handleOpenModal1}
                    disabled={signList?.length === 1}
                  >
                    Add Signature
                  </Button>
                </Box>
                {signList.length > 0
                  ? signList.map((item) => (
                      <>
                        <CardContent
                          sx={{
                            flex: 1,
                            overflowY: 'auto',
                          }}
                        >
                          <Typography
                            variant="body1"
                            sx={{ fontWeight: 'bold', mt: -3 }}
                            dangerouslySetInnerHTML={{ __html: item.signature.name }}
                          />
                        </CardContent>

                        <Divider sx={{ mb: 1 }} />
                        <Box sx={{ mt: 'auto', mb: 1, display: 'flex', justifyContent: 'center', gap: 3 }}>
                          <Button
                            color="custom"
                            size="small"
                            variant="contained"
                            onClick={() => handleOpenUpdateModal(item)}
                          >
                            Update
                          </Button>
                          <Button
                            color="custom"
                            size="small"
                            variant="contained"
                            onClick={() => handleOpenDeleteModal(item._id)}
                          >
                            Delete
                          </Button>
                        </Box>
                      </>
                    ))
                  : null}
              </Card>
            </Grid>

            {/* </Grid> */}

            <Grid item xs={12} sm={6}>
              <Card
                sx={{
                  position: 'relative',
                  border: '2px solid #1E74B3',
                  transition: 'transform 0.1s, box-shadow 0.1s',
                  height: 360,
                }}
              >
                <StyledCardMedia
                  sx={{
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 2,

                    '&:after': {
                      top: 0,
                      content: "''",
                      width: '100%',
                      height: '100%',
                      position: 'absolute',
                      // backgroundColor: 'rgba(35, 5, 5, 0.72)',
                      zIndex: 1,
                    },
                  }}
                >
                  <StyledAvatar
                    alt="Profile"
                    src={details?.profileImage}
                    sx={{
                      zIndex: 9,
                      width: 135,
                      height: 135,
                      position: 'relative',
                      top: 19,
                      left: 19,
                      border: '1px solid #1E74B3',
                    }}
                  />
                  <Box
                    sx={{
                      position: 'relative',
                      zIndex: 9,
                      top: 56,
                      left: 30,
                      gap: 2,
                    }}
                  >
                    <Typography
                      variant="h6"
                      component="div"
                      sx={{
                        fontWeight: 'bold',
                        fontSize: '17px',
                        textTransform: 'capitalize',
                      }}
                    >
                      {details1?.companyName}
                      {/* {localStorage.getItem("companyName")} */}
                    </Typography>
                    <Typography variant="body1" sx={{ fontSize: '17px', textTransform: 'capitalize' }}>
                      {details?.contactPersonName}
                    </Typography>
                    <Typography variant="body2" color={'text.secondary'} sx={{ fontSize: '17px' }}>
                      {details?.email}
                    </Typography>
                    {/* <Typography variant="body1" sx={{fontSize:"17px"}}>
                                         {details?.contactNo}
                                    </Typography> */}
                    <Typography variant="body1" sx={{ fontSize: '17px', textTransform: 'capitalize' }}>
                      {details?.country}
                    </Typography>

                    <Typography variant="body1" sx={{ fontSize: '17px', textTransform: 'capitalize' }}>
                      {details?.timeZone?.shortName?.toUpperCase()} - {details?.timeZone?.fullName}
                    </Typography>

                    {/* <Typography variant="body1" sx={{ fontSize: "17px" }}>
                                        {details?.country
                                            ? details.country?.charAt(0)?.toUpperCase() + details.country?.slice(1)?.toLowerCase()
                                            : ""}
                                    </Typography> */}
                  </Box>

                  <Box
                    sx={{
                      position: 'absolute',
                      top: 16,
                      right: 16,
                      display: 'flex',
                      gap: 1,
                      zIndex: 9,
                    }}
                  >
                    <Button
                      size="small"
                      variant="contained"
                      color="custom"
                      disabled={localStorage.getItem('role') === 'superadmin'}
                      sx={{ ml: 2 }}
                      onClick={() => modalOpene()}
                    >
                      Edit Profile
                      {/* Add Profile */}
                    </Button>
                  </Box>
                </StyledCardMedia>
              </Card>
            </Grid>
          </Grid>
        ) : (
          <Box
            sx={{
              width: '40%',
              margin: '35px auto',
              textAlign: 'center',
              padding: 3,
              borderRadius: 2,
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              backgroundColor: '#fff',
            }}
          >
            <Typography variant="h5" gutterBottom>
              Parse Candidate
            </Typography>

            <FormControl fullWidth sx={{ mb: 2 }}>
              <FormLabel>Select Both Files: Candidate and Notes</FormLabel>

              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
                <Button
                  variant="outlined"
                  component="label"
                  sx={{ fontWeight: 400, width: '60%', paddingTop: 1.2, paddingBottom: 1.2, fontSize: '18px' }}
                >
                  Select Files
                  <input
                    id="fileInput"
                    type="file"
                    multiple
                    accept=".csv, .xlsx"
                    hidden
                    onChange={selectMultiFile}
                    style={{
                      marginTop: '8px',
                      opacity: 0,
                      position: 'absolute',
                      left: 0,
                      right: 0,
                      cursor: 'pointer',
                    }}
                  />
                </Button>
              </Box>
            </FormControl>

            {files?.length > 0 && (
              <div
                style={{
                  marginBottom: '9px',
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                {files?.map((file, index) => (
                  <div
                    key={index}
                    style={{
                      width: '100%',
                      textAlign: 'center',
                      fontWeight: 600,
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {index + 1}. {file?.name}
                  </div>
                ))}
              </div>
            )}

            <Button
              variant="contained"
              color="custom"
              disabled={loadingFile || files.length === 0}
              onClick={handleUpload}
              sx={{
                padding: '10px 20px',
                borderRadius: '5px',
                fontWeight: 'bold',
                textTransform: 'none',
                // color: 'text.textG'
              }}
            >
              {loadingFile ? 'Uploading...' : 'Upload'}
            </Button>

            {message && (
              <Typography
                sx={{
                  mt: 2,
                  fontWeight: 'bold',
                  color: message.includes('successfully') ? 'green' : 'red',
                }}
              >
                {message}
              </Typography>
            )}
          </Box>
        )}
      </Stack>

      <Modal open={modalOpen1} onClose={handleCloseModal1}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '50%',
            bgcolor: 'background.paper',
            border: '3px solid #3C6BA5',
            boxShadow: 24,
            p: 3,
            borderRadius: 3,
          }}
        >
          <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
            Add Signature
          </Typography>
          <Divider sx={{ mb: 2, mt: 1 }} />
          <Grid item xs={12} sx={{ mt: 2 }}>
            {/* <CKEditor
                                                    editor={ClassicEditor}
                                                    data={name}
                                                    onChange={(event, editor) => {
                                                        const data = editor.getData();
                                                        setName(data);
                                                    }}
                                                /> */}

            <CKEditor
              editor={ClassicEditor}
              data={name}
              config={{
                // licenseKey: process.env.REACT_APP_TLK,
                extraPlugins: [MyCustomUploadAdapterPlugin],
                // toolbar: [
                //         "heading", "|",
                //         "bold", "italic", "link", "|",
                //         "undo", "redo", "|",
                //         "imageUpload"
                //       ]
              }}
              onChange={(event, editor) => {
                setName(editor.getData());
              }}
            />
          </Grid>
          <Stack flexDirection={'row'} gap={1} mt={2} sx={{ justifyContent: 'center' }}>
            <Button color="custom" variant="contained" onClick={AddSign}>
              Add
            </Button>
          </Stack>
        </Box>
      </Modal>

      <Modal open={deleteModalOpen} onClose={handleCloseDeleteModal}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '30%',
            bgcolor: 'background.paper',
            border: '3px solid #3C6BA5',
            boxShadow: 24,
            p: 3,
            borderRadius: 3,
          }}
        >
          <Typography variant="h6" color={'#3C6BA5'} textAlign={'center'}>
            Are you sure you want to delete this signature?
          </Typography>
          <Stack flexDirection={'row'} gap={2} mt={2} sx={{ justifyContent: 'center' }}>
            <Button color="custom" variant="contained" onClick={DeleteSign}>
              Yes
            </Button>
            <Button color="custom" variant="contained" onClick={handleCloseDeleteModal}>
              No
            </Button>
          </Stack>
        </Box>
      </Modal>

      <Modal open={modalOpen} onClose={handleCloseModal}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '50%',

            bgcolor: 'background.paper',
            border: '3px solid #3C6BA5',
            boxShadow: 24,
            p: 3,
            borderRadius: 3,
          }}
        >
          <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
            {selectedSignature ? 'Update Signature' : 'Add Signature'}
          </Typography>
          <Divider sx={{ mb: 2, mt: 1 }} />
          <CKEditor
            editor={ClassicEditor}
            data={updatedName}
            config={{
              // licenseKey: process.env.REACT_APP_TLK,
              // toolbar: [
              //   'heading', '|',
              //   'bold', 'italic', 'link', '|',
              //   'insertImage', 'undo', 'redo'
              // ],
              extraPlugins: [MyCustomUploadAdapterPlugin],
            }}
            onChange={handleUpdateNameChange}
          />
          <Stack flexDirection={'row'} gap={1} mt={2} sx={{ justifyContent: 'center' }}>
            <Button color="custom" variant="contained" onClick={selectedSignature ? UpdateSign : AddSign}>
              {selectedSignature ? 'Update' : 'Add'}
            </Button>
          </Stack>
        </Box>
      </Modal>
       <Modal
                     open={openQuestionModal}
                     onClose={() => setOpenQuestionModal(false)}
                    >
                    <Box
                      sx={{
                        width: 500,
                        bgcolor: "#fff",
                        p: 3,
                        borderRadius: 2,
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                       }}
                     >
                 <Typography variant="h6" mb={2} sx={{ textAlign: "center", color: "text.secondary" }}>
                    Add Fixed Question
                </Typography>
                  <Divider sx={{ mb: 2, mt:-2}}/>

                   <TextField 
                   fullWidth
                   type="number"
                   placeholder='Order'
                   value={orders}
                   onChange={(e) => setOrders(e.target.value)}
                   />

                   <TextField
                      fullWidth
                      multiline
                      rows={5}
                      sx={{ mt: 2 }} 
                      placeholder="Write your fixed question..."
                      value={fixedQuestion}
                      onChange={(e) => setFixedQuestion(e.target.value)}
                     />
      
                   <Stack
                     direction="row"
                     justifyContent="center"
                     spacing={2}
                     mt={3}
                   >
                   {/* <Button
                        variant="outlined"
                        onClick={() => setOpenQuestionModal(false)}
                      >
                       Cancel
                     </Button> */}
      
                   <Button
                     variant="contained"
      
                     onClick={() => {
                          console.log(fixedQuestion);
      
                         // API Call Here
                          addTechQuestions();
                          
                          
                         }}
                       >
                       Submit
                    </Button>
                  </Stack>
                </Box>
              </Modal>

              <Modal
  open={openEditQuestionModal}
  onClose={() => setOpenEditQuestionModal(false)}
>
  <Box
    sx={{
      width: 500,
      bgcolor: "#fff",
      p: 3,
      borderRadius: 2,
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
    }}
  >
    <Typography
      variant="h6"
      sx={{ textAlign: "center", color: "text.secondary" }}
    >
      Edit Fixed Question
    </Typography>

    <Divider sx={{ my: 2 }} />

    <TextField
      fullWidth
      type="number"
      placeholder="Order"
      value={orders}
      onChange={(e) => setOrders(e.target.value)}
    />

    <TextField
      fullWidth
      multiline
      rows={5}
      sx={{ mt: 2 }}
      placeholder="Write your fixed question..."
      value={fixedQuestion}
      onChange={(e) => setFixedQuestion(e.target.value)}
    />

    <Stack direction="row" justifyContent="center" mt={3}>
      <Button
        variant="contained"
        onClick={updateQuestion}
      >
        Update
      </Button>
    </Stack>
  </Box>
</Modal>

      <Modal open={showModal} onClose={modalClosee}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '35%',
            backgroundColor: 'white',
            border: '2px solid #1E74B3',
            borderRadius: '13px',
            padding: '1rem',
            outline: 'none',
            height: 'auto',
          }}
        >
          {/* <Typography 
                               variant="contained" textAlign={'center'} fontSize={"1rem"}>
                               Upload Profile Image 
                               </Typography> */}
          {/* <Typography
                        variant="body1"
                        sx={{
                            mx: 'auto', textAlign: 'center', fontWeight: "bold",
                            fontSize: "20px", color: '#3C6BA5',
                        }}

                    >
                        {loading}
                    </Typography> */}
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
            <Box flex={1} />
            <Typography variant="h5" color="#3C6BA5" textAlign="center" sx={{ flex: 1 }}>
              Profile
            </Typography>
            <Box flex={1} display="flex" justifyContent="flex-end">
              <Button color="custom" variant="contained" disabled={loadingBtn} onClick={() => UploadImage()}>
                {/* Save */}
                {loadingBtn ? <CircularProgress size={24} /> : 'Save'}
              </Button>
            </Box>
          </Box>

          <Divider sx={{ mb: 0.9 }} />

          <TextField
            label="Contact Person Name"
            //   size="small"
            value={contactPName}
            sx={{ width: '100%', background: 'text.background', mb: 1 }}
            onChange={(e) => setContactPName(e.target.value)}
          />

          {/* <FormControl  size="large" sx={{ width: '100%' }}>
            <InputLabel id="demo-simple-select-label">Country</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"

              value={country}
              label="Country"
              onChange={(e) => setCountry(e.target.value)}
            >
            
              {countries?.map((item) => (
                <MenuItem key={item.id} value={item.country}>
                  {item.country}
                </MenuItem>
              ))}
            </Select>
          </FormControl>  */}

     <FormControl size="large" sx={{ width: '100%' }}>
  <InputLabel id="demo-simple-select-label">Country</InputLabel>

  <Select
    labelId="demo-simple-select-label"
    value={country}
    label="Country"
    disabled={!isEditable}
    onChange={(e) => setCountry(e.target.value)}
  >
    {filteredCountries.map((item) => (
      <MenuItem key={item.id} value={item.country}>
        {item.country}
      </MenuItem>
    ))}
  </Select>
</FormControl>
         

          {/* <FormControl size="large" sx={{ width: '100%', mt:1 }}>
                    <InputLabel id="demo-simple-select-autowidth-label">Time zone</InputLabel>
                    <Select
                      labelId="demo-simple-select-autowidth-label"
                      id="demo-simple-select-autowidth"
                      label="Time Zone"
                      InputLabelProps={{ shrink: true }}
                      placeholder="Time zone"
                    //   value={timez}
                    //   onChange={(e) => setTimez(e.target.value)}
                    value={timez?.shortName?.toLowerCase() || ""}
        onChange={handleChange}
                    >
                      <MenuItem value={'est'}>EST</MenuItem>
                      <MenuItem value={'pst'}>PST</MenuItem>
                      <MenuItem value={'mst'}>MST</MenuItem>
                      <MenuItem value={'cst'}>CST</MenuItem>
                      <MenuItem value={'ist'}>IST</MenuItem>
                    </Select>
                  </FormControl> */}

          <FormControl fullWidth sx={{ mt: 1 }}>
            <InputLabel id="time-zone-label">Time Zone</InputLabel>
            <Select
              labelId="time-zone-label"
              id="time-zone-select"
              label="Time Zone"
              value={timeZone.shortName?.toLowerCase() || ''}
              onChange={handleChange}
            >
              {timeZones.map((tz) => (
                <MenuItem key={tz.short} value={tz.short?.toLowerCase()}>
                  {tz.short}
                  {' - '}
                  {tz.full}
                </MenuItem>
              ))}
            </Select>

            {/* <div style={{ marginTop: "10px" }}>
        <strong>Selected Time Zone:</strong> {timeZone.shortName} ({timeZone.fullName})
      </div> */}
          </FormControl>

          <label htmlFor="file-upload" style={{ cursor: 'pointer' }}>
            <div
              style={{
                border: '3px dashed #1E74B3',
                padding: '10px',
                borderRadius: '15px',
                margin: '1rem',
                // justifyContent: 'center',
                // alignItems: 'center',
                textAlign: 'center',
                color: '#1E74B3',
                // width: '330px',
                marginLeft: '25',
                alignContent: 'center',
              }}
            >
              <Typography variant="body1" fontWeight="bold" mb={1} mt={1}>
                Upload Image
              </Typography>
              <input
                id="file-upload"
                type="file"
                style={{ display: 'none' }}
                accept="image/png, image/jpeg, image/jpg"
                onChange={handleFileSelect}
                //   single
              />
            </div>
          </label>
          {/* <div> */}
          {/* {/ <Typography variant="body1">Uploaded Files</Typography> /} */}
          {/* <Typography
                        variant="body1"
                        sx={{ mx: 'auto', textAlign: 'center' }}

                    >
                        {fileInputFiles?.name}
                        {fileInputFiles?.name || fileInputFiles}

                    </Typography> */}

          <StyledAvatar
            alt="Profile"
            src={profileStore || localStorage.getItem('image')}
            sx={{
              // zIndex: 9,
              width: 95,
              height: 95,
              position: 'relative',
              top: 0.1,
              // left: "50%",
              ml: '33%',
              border: '1px solid #1E74B3',
            }}
          />
          {/* <Button
                    color="custom" variant="contained" 
                    sx={{}}
                    
                  >
                    Save
                    </Button> */}

          {/* </div> */}
        </Box>
      </Modal>
      <ToastContainer />
    </>
  );
}

//  function MyCustomUploadAdapterPlugin(editor) {
//   editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
//     return new Base64UploadAdapter(loader);
//   };
// }

// class Base64UploadAdapter {
//   constructor(loader) {
//     this.loader = loader;
//   }

//   upload() {
//     return this.loader.file.then(
//       (file) =>
//         new Promise((resolve, reject) => {
//           const reader = new FileReader();
//           reader.onload = () => resolve({ default: reader.result });
//           reader.onerror = (err) => reject(err);
//           reader.readAsDataURL(file);
//         })
//     );
//   }

//   abort() {
//   if (this.loader) {
//     // console.log("Upload aborted");
//   }
// }

// }
